import { createStore } from 'vuex'

import * as mutationTypes from './mutation-types'

import users from '@app/application/communication/sections/communication/store/users'
import checks from '@app/application/communication/sections/communication/store/checks'
import contexts from '@app/application/communication/sections/communication/store/contexts'
import attachments from '@app/application/communication/sections/communication/store/attachments'
import comments from '@app/application/communication/sections/communication/store/comments'
import notifications from './notifications'
import ui from '@app/application/communication/sections/communication/store/ui'
import remarks from '@app/application/communication/sections/communication/store/remarks'
import remarkTags from '@app/application/communication/sections/communication/store/remark-tags'
import sections from './sections'

import buildComms from '@app/application/communication/sections/communication/store/comms'

export default function createInboxStore(endpointParams, fetchCommunicationFn) {
  const { state, getters, mutations, actions } = buildComms(
    endpointParams,
    {},
    fetchCommunicationFn
  )

  const store = createStore({
    modules: {
      users,
      contexts,
      checks,
      attachments,
      comments: comments,
      ui,
      notifications,
      remarks,
      sections,
    },
    state() {
      return {
        ...state(),
        loading: {
          notifications: false,
          companies: false,
          workflows: false,
          mentionUsernames: false,
          communicationItem: false,
        },
      }
    },
    getters: {
      ...getters,
      loadingNotifications: ({ loading }) => loading.notifications,
      loadingWorkflows: ({ loading }) => loading.workflows,
    },
    mutations: {
      ...mutations,
      [mutationTypes.SET_LOADING](state, { type, value }) {
        state.loading[type] = value
      },
    },
    actions,
  })

  store.registerModule('remarkTags', remarkTags, { preserveState: true })

  return store
}
